import { render, staticRenderFns } from "./orderDevice.vue?vue&type=template&id=53f75c4e&scoped=true&"
import script from "./orderDevice.vue?vue&type=script&lang=js&"
export * from "./orderDevice.vue?vue&type=script&lang=js&"
import style0 from "./orderDevice.vue?vue&type=style&index=0&id=53f75c4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f75c4e",
  null
  
)

export default component.exports